import { render, staticRenderFns } from "./FreeConnections.vue?vue&type=template&id=92ebf5ec&scoped=true"
import script from "./FreeConnections.vue?vue&type=script&lang=js"
export * from "./FreeConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ebf5ec",
  null
  
)

export default component.exports